/**
 * @description 通知類別
*/
export enum NotifyType {
    /** Email OTP驗證信 */
    OMAIL = 'OMAIL',
    /** 會員註冊完成通知信 */
    NREG = 'NREG',
    /** 會員解鎖通知信 */
    NULK = 'NULK',
    /** 投保完成通知信-網路投保 */
    NACC = 'NACC',
    /** 投保完成通知信-網路要保 */
    NACB = 'NACB',
    /** 繳費通知信 */
    NPAY = 'NPAY',
    /** 交易取消通知信-未繳費 */
    NCNP = 'NCNP',
    /** 交易取消通知信-已繳費(信用卡) */
    NCPC = 'NCPC',
    /** 要保書收件通知信 */
    NAFA = 'NAFA',
    /** 補寄要保書通知信 */
    NAFR = 'NAFR'
}
